"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var d3_1 = require("d3");
var moment_1 = tslib_1.__importDefault(require("moment"));
var shape_1 = require("./shape");
var get_category_index_1 = require("../lib/get-category-index");
var hex_to_rgb_1 = require("../lib/hex-to-rgb");
var Line = /** @class */ (function (_super) {
    tslib_1.__extends(Line, _super);
    function Line(ctx, coord, helpers) {
        var _this = _super.call(this, ctx, coord, helpers) || this;
        /**
         * 分类轴数据比例尺类型
         * @since 2.0
         */
        _this.categoryScaleType = "Point";
        _this.canvasMode = false;
        _this.crosshair = _this.ctx.root
            .append("path")
            .attr("class", _this.ctx.classPrefix + "-chart-crosshair")
            .attr("data-z-index", "2")
            .attr("stroke", "#ECECEC")
            .attr("stroke-width", 1)
            .attr("style", "pointer-events:none;")
            .attr("visibility", "hidden");
        _this.ctx.on("plot.mouse.move", _this.onMouseMove, _this);
        _this.ctx.on("plot.mouse.left", _this.removeHover, _this);
        _this.ctx.on("plot.mouse.click", _this.onClick, _this);
        _this.ctx.on("legend.hover", _this.onLegendItemHover, _this);
        _this.ctx.on("legend.left", _this.onLegendItemLeft, _this);
        _this.ctx.on("legend.clicked", _this.onLegendClick, _this);
        _this.ctx.on("coord.zoom.zooming", _this.onZoom, _this);
        _this.ctx.on("coord.zoom.reset", _this.onZoomReset, _this);
        return _this;
    }
    /**
     * @implements Shape
     * @param pos 数据映射关系
     * @since 2.0
     */
    Line.prototype.position = function (pos) {
        var _a;
        this.model.source(this.ctx.dataSource);
        if (typeof pos === "string") {
            _a = tslib_1.__read(pos.split("*"), 2), this.categoryKey = _a[0], this.valueKey = _a[1];
        }
        return this;
    };
    /**
     * @implements
     * @param {string} color 作为数据系列映射字段
     * @param {Color} color 以 Color 的配置来设置颜色与数据系列映射关系
     * @since 2.0
     */
    Line.prototype.color = function (color) {
        if (typeof color === "string") {
            this.serieKey = color;
        }
        else if (Array.isArray(color)) {
            this.ctx.theme.color = color;
        }
        else if (typeof color === "object" && color !== null) {
            var key = color.key, formatter = color.formatter, colors = color.colors;
            this.serieKey = key;
            if (colors) {
                this.ctx.theme.color = colors;
            }
            else {
                this.ctx.theme.color = null;
            }
            if (formatter) {
                this.colorAttrCallback = formatter;
            }
        }
        else {
            this.serieKey = null;
        }
        this.colorKey = this.serieKey;
        return this;
    };
    Line.prototype.size = function (size) {
        this.shapeSize = size;
        return this;
    };
    /**
     * 设置坐标轴配置
     * @param axis 坐标轴配置
     * @since 2.0
     */
    Line.prototype.axis = function (axis) {
        if (axis.xAxis) {
            this.ctx.setOption("axis.xAxis", axis.xAxis);
        }
        if (axis.yAxis) {
            this.ctx.setOption("axis.yAxis", axis.yAxis);
        }
        return this;
    };
    /**
     * 设置图例
     * @param enable 是否显示图例
     * @param connectNullsCfg 连接空值配置
     * @since 2.0
     */
    Line.prototype.connectNulls = function (enable, connectNullsCfg) {
        if (connectNullsCfg === void 0) { connectNullsCfg = {}; }
        var cfg = typeof enable === "boolean"
            ? tslib_1.__assign({ enable: enable }, connectNullsCfg) : tslib_1.__assign({}, enable);
        cfg.enable = typeof cfg.enable === "boolean" ? cfg.enable : true;
        this.ctx.setOption("connectNulls", cfg);
        return this;
    };
    /**
     * @implements
     * @since 2.0
     */
    Line.prototype.updateModel = function () {
        var xSort = null;
        var _a = this.ctx.getOption("scale." + this.categoryKey, {
            type: "category",
            timeParseFormat: false,
        }), type = _a.type, timeParseFormat = _a.timeParseFormat;
        if (type === "time") {
            xSort = function (a, b) {
                return d3_1.ascending(moment_1.default(a, timeParseFormat).valueOf(), moment_1.default(b, timeParseFormat).valueOf());
            };
        }
        var maxCount = Number(this.ctx.background.attr("width"));
        var stack = this.ctx.getOption("scale." + this.valueKey, {
            stack: false,
        }).stack;
        this.model.define(this.categoryKey, this.valueKey, this.serieKey, this.colorKey, xSort, stack, "stack");
        var len = this.model.getCategoryNames().length;
        var interval = Math.floor(len / maxCount);
        var canvasMode = this.options.canvasMode;
        this.canvasMode =
            typeof canvasMode === "boolean"
                ? canvasMode
                : !!(maxCount && len > maxCount && interval);
    };
    /**
     * 更新颜色比例尺
     * @implements
     * @since 2.0
     */
    Line.prototype.updateColorScale = function () {
        var colorDomain = this.model.getKeyNames(this.colorKey);
        var _a = this.ctx.theme, color = _a.color, defaultColor = _a.defaultColor;
        var colorRange = [];
        if (typeof color === "function") {
            for (var i = 0; i < colorDomain.length; i++) {
                colorRange.push(color(colorDomain[i], i, i === colorDomain.length - 1));
            }
        }
        else if (Array.isArray(color)) {
            colorRange = color;
        }
        else {
            colorRange = defaultColor;
        }
        this.colorScale = d3_1.scaleOrdinal()
            .domain(colorDomain)
            .range(colorRange);
    };
    /**
     * 更新数据比例尺
     * @implements
     * @since 2.0
     */
    Line.prototype.updateDataScale = function () {
        this.categoryScale = d3_1.scalePoint().domain(this.model.getCategoryNames());
        var domain = this.ctx.getOption("scale." + this.valueKey, {
            domain: null,
        }).domain;
        var autofit = domain === "autofit";
        var valueDomain = Array.isArray(domain)
            ? domain
            : this.model.getExtent(autofit);
        this.valueScale = d3_1.scaleLinear()
            .domain(valueDomain)
            .nice(5);
    };
    /**
     * 开始绘图
     * @implements
     * @since 2.0
     */
    Line.prototype.draw = function (updateModel, updateColorScale, updateDataScale) {
        if (updateModel === void 0) { updateModel = true; }
        if (updateColorScale === void 0) { updateColorScale = true; }
        if (updateDataScale === void 0) { updateDataScale = true; }
        if (updateModel)
            this.updateModel();
        if (updateColorScale)
            this.updateColorScale();
        if (updateDataScale)
            this.updateDataScale();
        // 先更新图例的位置
        this.helpers.legend.update(this.colorScale, this.valueKey, "line", this.model);
        // 更新坐标轴
        this.coordinate.draw(this.valueScale, this.categoryScale, this.categoryScaleType, this.invert);
        // 全部的分类比例尺
        this.allCategoryScale = Object.assign({}, this.categoryScale).domain(this.model.getCategoryNames(true));
        this.drawSeries();
        var _a = this.ctx.getOption("interaction"), brush = _a.brush, zoom = _a.zoom;
        this.helpers.selection.setEnable(!!brush || !!zoom);
    };
    /**
     * 绘制折线图
     * @since 2.0
     */
    Line.prototype.drawSeries = function () {
        var e_1, _a, e_2, _b, e_3, _c;
        var _d = this.ctx, classPrefix = _d.classPrefix, id = _d.id;
        var smooth = this.options.smooth;
        var series = this.model.getSerieNames();
        var categories = this.model.getCategoryNames(true);
        var categoryScale = this.allCategoryScale;
        var serieCls = classPrefix + "-chart-series " + classPrefix + "-chart-line-series";
        var markersCls = classPrefix + "-chart-markers " + classPrefix + "-chart-line-series";
        var shape = this;
        this.seriesGroup.selectAll("g").remove();
        var datum = {};
        try {
            for (var categories_1 = tslib_1.__values(categories), categories_1_1 = categories_1.next(); !categories_1_1.done; categories_1_1 = categories_1.next()) {
                var cat = categories_1_1.value;
                var dataPoints = this.model.getDataFromCategoryName(cat, false, true);
                try {
                    for (var dataPoints_1 = (e_2 = void 0, tslib_1.__values(dataPoints)), dataPoints_1_1 = dataPoints_1.next(); !dataPoints_1_1.done; dataPoints_1_1 = dataPoints_1.next()) {
                        var point = dataPoints_1_1.value;
                        var category = point.category, serieName = point.serieName, colorName = point.colorName;
                        var value = shape.model.get(cat, serieName);
                        var x = categoryScale(cat);
                        var y = shape.valueScale(value);
                        var color = shape.colorScale(colorName);
                        if (!datum[serieName])
                            datum[serieName] = [];
                        datum[serieName].push({
                            value: value,
                            x: x,
                            y: y,
                            color: color,
                            metric: null,
                            category: category,
                            originValue: value,
                            dataLeaf: point,
                        });
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (dataPoints_1_1 && !dataPoints_1_1.done && (_b = dataPoints_1.return)) _b.call(dataPoints_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (categories_1_1 && !categories_1_1.done && (_a = categories_1.return)) _a.call(categories_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var connectNulls = this.ctx.getOption("connectNulls").enable;
        var _e = this, colorAttrCallback = _e.colorAttrCallback, ctx = _e.ctx;
        // 大数据模式使用 Canvas
        if (this.canvasMode) {
            this.seriesGroup.selectAll("g").remove();
            var imageGroup = this.seriesGroup
                .append("g")
                .attr("class", serieCls + " " + classPrefix + "-chart-series-0")
                .attr("data-z-index", 0)
                .attr("clip-path", "url(#" + id + ")");
            var canvas = document.createElement("canvas");
            var width = Number(ctx.background.attr("width"));
            var height = Number(ctx.background.attr("height"));
            canvas.width = width * window.devicePixelRatio;
            canvas.height = height * window.devicePixelRatio;
            canvas.setAttribute("style", "width:" + width + "px;height:" + height + "px");
            var canvasCtx = canvas.getContext("2d");
            canvasCtx.scale(window.devicePixelRatio, window.devicePixelRatio);
            canvasCtx.translate(0, 0);
            try {
                for (var series_1 = tslib_1.__values(series), series_1_1 = series_1.next(); !series_1_1.done; series_1_1 = series_1.next()) {
                    var serieName = series_1_1.value;
                    var data = datum[serieName] || [];
                    var defaultColor = void 0;
                    var _f = data[0] || {}, dataLeaf = _f.dataLeaf, _g = _f.color, dColor = _g === void 0 ? "none" : _g;
                    if (colorAttrCallback) {
                        defaultColor = colorAttrCallback(dataLeaf);
                    }
                    defaultColor = defaultColor || dColor;
                    var lineData = connectNulls
                        ? data.filter(function (_a) {
                            var value = _a.value;
                            return typeof value === "number";
                        })
                        : data;
                    var lineGenerator = d3_1.line()
                        .defined(function (_a) {
                        var value = _a.value;
                        return connectNulls ? true : typeof value === "number";
                    })
                        .x(function (_a) {
                        var x = _a.x;
                        return x;
                    })
                        .y(function (_a) {
                        var y = _a.y;
                        return y;
                    })
                        .curve(smooth ? d3_1.curveMonotoneX : d3_1.curveLinear);
                    canvasCtx.beginPath();
                    lineGenerator.context(canvasCtx);
                    lineGenerator(lineData);
                    canvasCtx.lineWidth = shape.shapeSize;
                    canvasCtx.strokeStyle = hex_to_rgb_1.hexToRGB(defaultColor, this.highlightKey && this.highlightKey !== serieName ? 0.1 : 1);
                    canvasCtx.stroke();
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (series_1_1 && !series_1_1.done && (_c = series_1.return)) _c.call(series_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            imageGroup
                .append("image")
                .attr("class", classPrefix + "-chart-shape-canvas")
                .attr("x", 0)
                .attr("y", 0)
                .attr("width", width)
                .attr("height", height)
                .attr("href", canvas.toDataURL())
                .attr("style", "pointer-events:none;mixed-blend-mode:normal;opacity:" + 1 + ";");
        }
        else {
            this.seriesGroup
                .selectAll("." + serieCls)
                .data(series)
                .join("g")
                .attr("class", function (_, i) { return serieCls + " " + classPrefix + "-chart-series-" + i; })
                .attr("data-z-index", function (_, i) { return series.length - i - 1; })
                .attr("clip-path", "url(#" + id + ")")
                .call(function (g) {
                g.each(function serie(serieName) {
                    var serieGroup = d3_1.select(this);
                    var data = datum[serieName] || [];
                    var defaultColor;
                    var _a = data[0] || {}, dataLeaf = _a.dataLeaf, _b = _a.color, dColor = _b === void 0 ? "none" : _b;
                    if (colorAttrCallback) {
                        defaultColor = colorAttrCallback(dataLeaf);
                    }
                    defaultColor = defaultColor || dColor;
                    var lineData = connectNulls
                        ? data.filter(function (_a) {
                            var value = _a.value;
                            return typeof value === "number";
                        })
                        : data;
                    var lineGenerator = d3_1.line()
                        .defined(function (_a) {
                        var value = _a.value;
                        return connectNulls ? true : typeof value === "number";
                    })
                        .x(function (_a) {
                        var x = _a.x;
                        return x;
                    })
                        .y(function (_a) {
                        var y = _a.y;
                        return y;
                    })
                        .curve(smooth ? d3_1.curveMonotoneX : d3_1.curveLinear);
                    // 绘制可见折线
                    serieGroup
                        .append("path")
                        .attr("fill", "none")
                        .attr("class", classPrefix + "-chart-shape-missing")
                        .attr("data-z-index", "1")
                        .attr("stroke", defaultColor)
                        .attr("stroke-width", shape.shapeSize)
                        .attr("stroke-linejoin", "round")
                        .attr("stroke-linecap", "round")
                        .attr("d", function () { return lineGenerator(lineData); });
                });
            });
        }
        this.seriesGroup
            .selectAll("." + markersCls)
            .data(series)
            .join("g")
            .attr("class", function (_, i) { return markersCls + " " + classPrefix + "-chart-series-" + i; })
            .attr("data-z-index", function (_, i) { return series.length - i - 1; });
        var maxSerieIndex = series.length;
        for (var start = 0; start <= maxSerieIndex; start++) {
            this.seriesGroup
                .selectAll("." + classPrefix + "-chart-series-" + start)
                .raise();
        }
    };
    Line.prototype.onMouseMove = function (x, y) {
        var tooltipEnable = this.ctx.getOption("tooltip.enable");
        if (tooltipEnable === false)
            return;
        var data = this.getData(x, y);
        if (data) {
            var allData = this.model.getAllData();
            this.helpers.tooltip.show(data, allData);
            clearTimeout(this.timer);
            this.drawHover(data);
            if (this.ctx.getOption("interaction.element-hover")) {
                if (this.currentHoverIndex !== data.index) {
                    this.ctx.emit("interaction.hover", data.metaData);
                    this.currentHoverIndex = data.index;
                }
            }
        }
        else {
            this.removeHover();
        }
    };
    /**
     * 根据坐标获取数据
     * @since 2.0
     * @param x x 坐标
     * @param y y 坐标
     */
    Line.prototype.getData = function (x, y) {
        var e_4, _a;
        var scale = this.allCategoryScale;
        if (!scale) {
            return {
                x: 0,
                y: 0,
                metaData: [],
                index: 0,
                category: "default",
            };
        }
        var domain = scale.domain();
        var index = get_category_index_1.getCategoryIndex(x, scale, "Point");
        var xValue = domain[index];
        var xPos = xValue ? scale(xValue) : x;
        if (index < 0 || Number.isNaN(index))
            return null;
        if (index > domain.length - 1) {
            index = domain.length - 1;
        }
        var alias = this.ctx.getOption("scale." + this.valueKey + ".alias");
        var metaData = [];
        var values = this.model.getDataFromCategoryName(xValue, false, false);
        if (values.length === 0)
            return null;
        try {
            for (var values_1 = tslib_1.__values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                var _b = values_1_1.value, serieName = _b.serieName, value_1 = _b.value, origin_1 = _b.origin, colorName = _b.colorName;
                metaData.push({
                    title: xValue,
                    label: alias || (this.serieKey === null ? this.valueKey : serieName),
                    serieName: serieName,
                    valueText: typeof value_1 === "number" ? d3_1.format(",")(value_1) : "-",
                    color: this.colorScale(colorName),
                    value: value_1,
                    row: origin_1,
                });
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        var _c = tslib_1.__read(values, 1), value = _c[0].value;
        return {
            x: xPos,
            y: y === undefined ? this.valueScale(value) : y,
            category: xValue,
            metaData: metaData,
            index: index,
        };
    };
    /**
     * 通过分类坐标名获取数据
     * @param category
     */
    Line.prototype.getDataFromCategory = function (category) {
        var e_5, _a;
        var alias = this.ctx.getOption("scale." + this.valueKey + ".alias");
        var metaData = [];
        var values = this.model.getDataFromCategoryName(category, false, false);
        if (values.length === 0)
            return null;
        try {
            for (var values_2 = tslib_1.__values(values), values_2_1 = values_2.next(); !values_2_1.done; values_2_1 = values_2.next()) {
                var _b = values_2_1.value, serieName = _b.serieName, value = _b.value, origin_2 = _b.origin, colorName = _b.colorName;
                metaData.push({
                    title: category,
                    label: alias || (serieName === "default" ? this.valueKey : serieName),
                    serieName: serieName,
                    valueText: typeof value === "number" ? d3_1.format(",")(value) : "-",
                    color: this.colorScale(colorName),
                    value: value,
                    row: origin_2,
                });
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (values_2_1 && !values_2_1.done && (_a = values_2.return)) _a.call(values_2);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return metaData;
    };
    /**
     * 通过值获取坐标
     * @param category 分类值
     * @param value 数据值
     */
    Line.prototype.getPosition = function (category, value) {
        var categoryScale = this.categoryScale;
        return [categoryScale(category), this.valueScale(value)];
    };
    /**
     * 绘制标记线和标记点
     * @param eventData 当前数据点信息
     * @since 2.0
     * @todo 修复最后一个点不显示的问题
     */
    Line.prototype.drawHover = function (eventData) {
        var _this = this;
        var x = eventData.x, category = eventData.category, metaData = eventData.metaData;
        var offsetY = parseInt(this.ctx.plotBackgound.attr("y"), 10);
        var height = parseInt(this.ctx.plotBackgound.attr("height"), 10);
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
            // 绘制标记线
            _this.crosshair
                .attr("d", "M" + x + "," + offsetY + "L" + x + "," + (height + offsetY))
                .attr("visibility", "visible");
            var markers = _this.seriesGroup.selectAll("." + _this.ctx.classPrefix + "-chart-markers");
            markers.selectAll("circle").attr("opacity", 0);
            markers
                .selectAll("circle")
                .data(metaData)
                .join("circle")
                .attr("class", _this.ctx.classPrefix + "-chart-point")
                .attr("r", 4)
                .attr("stroke", function (_a) {
                var color = _a.color;
                return color;
            })
                .attr("fill", "#FFF")
                .attr("stroke-width", 2)
                .attr("opacity", 1)
                .attr("visibility", function (_a) {
                var value = _a.value;
                return value === null ? "hidden" : "visible";
            })
                .attr("transform", function (_a) {
                var serieName = _a.serieName;
                var x = _this.allCategoryScale(category);
                var value = _this.model.get(category, serieName);
                var y = _this.valueScale(value);
                return "translate(" + x + ", " + y + ")";
            });
        }, 0);
    };
    /**
     * 隐藏标记线和标记点
     * @since 2.0
     */
    Line.prototype.removeHover = function () {
        this.crosshair.attr("visibility", "hidden");
        this.seriesGroup
            .selectAll("." + this.ctx.classPrefix + "-chart-markers circle")
            .attr("opacity", "0");
        this.helpers.tooltip.hide();
    };
    /**
     * 监听图例事件
     * @param legendData LegendData
     */
    Line.prototype.onLegendItemHover = function (_a) {
        var key = _a.key;
        this.highlightKey = key;
        if (this.canvasMode) {
            this.drawSeries();
        }
        else {
            this.seriesGroup
                .selectAll("." + this.ctx.classPrefix + "-chart-series")
                .call(function (g) {
                g.each(function highlight(groupKey) {
                    var ele = d3_1.select(this);
                    if (groupKey === key) {
                        ele.attr("opacity", 1);
                    }
                    else {
                        ele.attr("opacity", 0.1);
                    }
                });
            });
        }
    };
    /**
     * 监听图例事件
     * @param legendData LegendData
     */
    Line.prototype.onLegendItemLeft = function () {
        this.highlightKey = null;
        if (this.canvasMode) {
            this.drawSeries();
        }
        else {
            this.seriesGroup
                .selectAll("." + this.ctx.classPrefix + "-chart-series")
                .call(function (g) {
                g.each(function highlight() {
                    var ele = d3_1.select(this);
                    ele.attr("opacity", 1);
                });
            });
        }
    };
    /**
     * 图例点击事件
     * @param legendData 被点击的图例信息
     * @param disabled 改图例元素是否是禁用状态
     */
    Line.prototype.onLegendClick = function (legendData, disabled) {
        var key = legendData.key;
        if (disabled) {
            this.disabledKeys.push(key);
        }
        else {
            this.disabledKeys = this.disabledKeys.filter(function (d) { return d !== key; });
        }
        this.model.filterColumns(this.disabledKeys);
        this.draw(false);
    };
    Line.prototype.onClick = function (x, y) {
        var mappedData = this.getData(x, y);
        if (mappedData) {
            this.ctx.emit("click", mappedData);
        }
    };
    Line.prototype.onZoom = function (range) {
        this.model.range(range);
        this.draw(false, false, true);
    };
    Line.prototype.onZoomReset = function () {
        this.draw();
    };
    return Line;
}(shape_1.Shape));
exports.Line = Line;
//# sourceMappingURL=line.js.map